
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 12.61"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path","transform":"translate(-14.07 -18.88)"}},[_c('path',{attrs:{"fill":"none","d":"M-575-455H625v959.5H-575z"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"stroke":"#206fa1","stroke-linecap":"round","stroke-miterlimit":"10","fill":"none","d":"M20.5.5l-9.91 11.35L.5.5"}})])])
          )
        }
      }
    